import * as io from "io-ts";

export const MaybeStringResolver = io.union([io.string, io.null]);

export const MaybeNumberResolver = io.union([io.number, io.null]);

export const MaybeStringArrayResolver = io.union([io.array(io.string), io.null]);
